import { navigate } from 'gatsby';
import React, { useEffect } from 'react';

import PrivateRoute from '@components/PrivateRoute';

import { DASHBOARD } from '@constants/routes';

import { useSession } from '@hooks/useSession';

import { getQueryParams } from '@utils/url';

export default function Loader() {
  const {
    state: { loggedInProfile },
  } = useSession();
  const [user_id] = [loggedInProfile?.user_id];

  useEffect(() => {
    if (user_id) {
      const { redirect_uri } = getQueryParams();
      if (Boolean(redirect_uri?.length) && typeof redirect_uri === 'string') {
        // decode then pass into navigate
        navigate(redirect_uri);
      } else {
        // TODO Direct to different dashboards for users, admins, etc...
        navigate(DASHBOARD);
      }
    }
  }, [user_id]);

  return <PrivateRoute />;
}
